export default __webpack_public_path__ + "d460520d54f6045fe1cfc78802da8298.png";